import { Enums } from "../common/enums";
import { OpImportData } from "./op-import-data";
import { OpImportItemSummary } from "./op-import-item-summary";

export class OpImportSummary {

    //Properties

    public guid: string
    public dllName: string
    public fileName: string
    public importObject: any
    public importStatus: Enums.ImportStatus
    public itemSummary: OpImportItemSummary[]

    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.guid = opObj.Guid
            this.dllName = opObj.DllName
            this.fileName = opObj.FileName
            if (opObj.ImportObject)
                this.importObject = new OpImportData(opObj.ImportObject)
            if (this.itemSummary)
                this.itemSummary = opObj.ItemSummary.map(data => new OpImportItemSummary(data))
        }
    }
}